import { ReactNode } from 'react';

import { appendTestableComponentAttributes, StyledFlex, TestableComponentProps } from '@dreryk/react-components';

type PrescriptionPackageViewProps = TestableComponentProps & {
   readonly header?: ReactNode | null;
   readonly children: ReactNode;
};

export const PrescriptionPackageView = (props: PrescriptionPackageViewProps): JSX.Element => {
   const { testId, header, children } = props;
   return (
      <StyledFlex
         direction={'column'}
         gap={'8px'}
         {...appendTestableComponentAttributes('PrescriptionPackageView', testId)}
      >
         {header}
         <StyledFlex direction={'column'} gap={'8px'}>
            {children}
         </StyledFlex>
      </StyledFlex>
   );
};
